import React, { useContext } from 'react';
import { Modal } from './Modal.component';
import { ModalButtonActionType } from './ModalButtonActionType.enum';
import { ModalContext } from './ModalContext';
import Session from '../utils/Session';

export const DirtyStateModal = ({ data, modalId }) => {
	const { size = 'small', callback, ...rest } = data;
	const { closeModal } = useContext(ModalContext);

	const onLeaveButtonClick = () => {
		// resets for components that do not use dirty state
		Session.setFormStateDirty(false);

		closeModal(modalId, ModalButtonActionType.Ok, callback({ ...rest }));
	};

	const primaryButton = {
		type: ModalButtonActionType.Ok,
		text: 'Leave Page',
		onClick: onLeaveButtonClick,
		dataqa: 'dirty-state-leave-page-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'Cancel',
		dataqa: 'dirty-state-cancel-button',
	};

	return (
		<Modal
			modalId={modalId}
			className="dirty-state-modal warning-modal"
			header="Unsaved Changes"
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size={size}
		>
			<div className="body">
				<p>
					You have unsaved changes on this page. Would you like to leave the page without
					saving your changes?
				</p>
			</div>
		</Modal>
	);
};
